<template>
  <!-- <main-area> -->
  <div class="homePage">
    <div class="bannerBgc">
      <div class="pagew bg">
        <!-- <div class="banner-text-box">
            <p>湖南旭麓新材料科技有限公司成立于2019年，是一家集新型功能材料和元器件技术研发、生产和销售为一体的高科技企业。公司聘请多位国家高层次人才为研发顾问，以硕博人才为主体，与多所985高校建立合作，具备优秀的材料、器件研发能力和广阔的发展前景。</p>
          </div> -->
      </div>
    </div>

    <!-- 主要内容部分 -->
    <div class="pagew announcement">
      <!-- 公司介绍部分 -->
      <div class="introduce">
        <div class="title">
          公司介绍
        </div>
        <div class="content">
          <div class="left-content">
            <div class="top-info">
              &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp湖南旭麓新材料科技有限公司成立于2019年，是一家集新型功能材料和元器件技术研发、生产和销售为一体的高科技企业。公司聘请多位国家高层次人才为研发顾问，以硕博人才为主体，与多所985高校建立合作，具备优秀的材料、器件研发能力和广阔的发展前景。
            </div>
            <!-- <div class="bottom-btn">查看更多</div> -->
          </div>
          <div class="right-content">
            <img class="img" src="../../assets/other/company-building.jpg" alt="" />
          </div>
        </div>
      </div>
      <!-- 产品中心部分 -->
      <div class="product">
        <div class="title">产品中心 </div>
        <!-- <div class="top-search">
          <input type="text" placeholder="请输入搜索关键词" />
          <img class="icon" src="../../assets/other/icons/search.png" alt="" />
        </div> -->
        <div class="bottom-info">
          <div class="info-item">
            <div class="product-center">
              <span class="icon1"></span>产品中心
            </div>
            <div  :class="[isActive1?'type1':'type2']"  @click="changeIt1(isActive1)"><span class="icon2"></span>噻吩并噻吩类</div>
            <div  :class="[isActive2?'type1':'type2']"  @click="changeIt2(isActive2)"><span class="icon2"></span>噻吩类</div>
            <div  :class="[isActive3?'type1':'type2']"  @click="changeIt3(isActive3)"><span class="icon2"></span>IC类</div>
            <div class="more" @click="gotolink">查看更多<span class="type3">></span></div>
          </div>
          <div class="center-info">
            <div :class="[isActive1?'center-img':'center-img1']" @click="gotolink1">
            <div class="img">
              <img src="../../assets/other/element/5.jpg" alt="" />
            </div>
            <div class="txt">
              <div>3-hexylthieno[3,2-b]thiophene</div>
              <div>3-己基-噻吩并【3,2-B】噻吩</div>
              <div>CAS NO:880088-89-1</div>
              <!-- <div class="tab">
                <div class="left"></div>
                <div class="right">></div>
              </div> -->
            </div>
          </div>
          </div>
          <div class="right-info">
            <div :class="[isActive2?'top-img':'top-img1']"  @click="gotolink2">
              <div class="img">
                <img src="../../assets/other/element/6.jpg" alt="" />
              </div>
              <div class="txt">
                <div>3-Hexylthiophene</div>
                <div>3-己基噻吩</div>
                <div>CAS NO:1693-86-3</div>
              </div>
            </div>
            <div :class="[isActive3?'bottom-img':'bottom-img1']"  @click="gotolink3">
              <div class="img">
                <img src="../../assets/other/element/9.jpg" alt="" />
              </div>
              <div class="txt">
                <div>IC-Br (in)</div>
                <div>5-溴-3-(二氰基亚甲基)靛酮</div>
                <div>CAS NO:2304026-60-4</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 服务优势部分 -->
      <div class="service">
        <div class="title">服务优势</div>
        <div class="service-info">
          <div class="item">
            <div class="img">
              <img src="../../assets/other/icons/bulb.png" alt="" />
            </div>
            <div class="text">
              <div class="tip">
                优秀的研发能力
              </div>
              <div class="top-info">
                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp公司拥有一支年龄、学历、专业结构合理，高水平、高素质的技术研发团队并且聘请多位国家高层次人才为研发顾问，与多所985高校建立合作，具备优秀的材料、器件研发能力和广阔的发展前景。
              </div>
            </div>
          </div>
          <div class="item">
            <div class="img">
              <img src="../../assets/other/icons/sincerity.png" alt="" />
            </div>
            <div class="text">
              <div class="tip">
                良好的行业信誉
              </div>
              <div class="top-info">
              &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp公司拥有多项相关领域的专利，凭借实力雄厚的技术研发平台、精良的设备、先进的检验技术和产品、优质的服务、良好的信誉赢得了广大客户的一致认可。
            </div>
            </div>
          </div>
        </div>
      </div>
      <!--  <div class="pagew bar-title">
        <div class="imgbox">
          <img src="../../assets/image/index/news-bar.png" />
        </div>
        <p
          style="margin-top: 36px; font-size: 24px; font-weight: 700; line-height: 20px"
          class="img-title"
        >
          产品展示
        </p>
        <p
          style="margin-top: 36px; font-size: 18px; font-weight: 500; line-height: 20px"
          class="img-title"
        >
          Product Show
        </p>
      </div>
      <div class="announcement_content">
        <div class="announcement_video" @click="gotoWorks">
          <br /><br />
          <img src="../../assets/image/chemistry.jpg" />
        </div>
        <div class="announcement_text">
          <div class="button" style="cursor:pointer" @click="gotoWorks">
            查看更多 &gt;&gt;
          </div>
          <div class="news-box">
            <div @click="gotoWorks" class="texts">
              <img src="../../assets/image/product/1.1.png" />
            </div>
            <div @click="gotoWorks" class="texts">
              <img src="../../assets/image/product/1.2.png" />
            </div>
            <div @click="gotoWorks" class="texts">
              <img src="../../assets/image/product/1.3.png" />
            </div>
            <div @click="gotoWorks" class="texts">
              <img src="../../assets/image/product/1.4.png" />
            </div>
          </div>
        </div>
      </div> -->
      <br /><br />
    </div>
    <Footer :show="true" />
  </div>
  <!-- </main-area> -->
</template>

<script>
import MainArea from "@/components/MainArea";
import news from "./components/news.vue";
import { getNewsList } from "@/api/api.js";
export default {
  components: { MainArea, news },
  data() {
    return {
      activeName: "LogoCanvas",
      carHeight: "400px",
      workList: [{}, {}, {}],
      hotList: [],
      timeline: [
        { id: "1", name: "第一届", t: "2005" },
        { id: "2", name: "第二届", t: "2022" },
        { id: "3", name: "第三届", t: "2022" },
        { id: "4", name: "第四届", t: "2022" },
        { id: "5", name: "第五届", t: "2022" },
        { id: "6", name: "第六届", t: "2022" },
        { id: "7", name: "第七届", t: "2022" },

        { id: "8", name: "第八届", t: "2022" },
        { id: "9", name: "第九届", t: "2022" },
        { id: "10", name: "第十届", t: "2022" },
        { id: "11", name: "第十一届", t: "2022" },
        { id: "12", name: "第十二届", t: "2022" },
        { id: "13", name: "第十三届", t: "2022" },
        { id: "14", name: "第十四届", t: "2022" },
        { id: "15", name: "第十五届", t: "2022" },
        { id: "16", name: "第十六届", t: "2022" },
        { id: "17", name: "第十七届", t: "2022" }
      ].reverse(),
      flexArr: [
        {
          title: "主赛道",
          img: require("@/assets/image/zhusaidao.png")
        },
        {
          title: "港澳台创新设计对接赛",
          img: require("@/assets/image/duijie.png")
        },
        {
          title: "企业设计命题专项赛",
          img: require("@/assets/image/zhuanti.png")
        }
      ],
      judgesArr: [
        {
          name: "张三",
          url: require("@/assets/image/pingwei.png"),
          introduction:
            "他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三"
        },
        {
          name: "赵四",
          url: require("@/assets/image/goodbit.png"),
          introduction: "他是赵四"
        },
        {
          name: "王五",
          url: require("@/assets/image/zhuban2.png"),
          introduction: "他是王五"
        },
        {
          name: "李六",
          url: require("@/assets/image/yin.png"),
          introduction: "他是李六"
        },
        {
          name: "赵四",
          url: require("@/assets/image/goodbit.png"),
          introduction: "他是赵四"
        },
        {
          name: "王五",
          url: require("@/assets/image/zhuban2.png"),
          introduction: "他是王五"
        },
        {
          name: "李六",
          url: require("@/assets/image/yin.png"),
          introduction: "他是李六"
        }
      ],
      translateY: 0,
      activeIndex: 0,
      isActive1: true,
      isActive2: true,
      isActive3: true,
    };
  },
  /*  created() {
    this.getNewsList();

    const wwidth = (window.innerWidth / 1920) * 596;
    this.carHeight = `${Math.floor(wwidth)}px`;
  }, */
  methods: {
    changeIt1(a){
        this.isActive1 = !this.isActive1; 
        if (this.isActive1 == false) {
            this.isActive2 = true;
            this.isActive3 = true;
        } 
    },
    changeIt2(a){
        this.isActive2 = !this.isActive2;
        if (this.isActive2 == false) {
            this.isActive1 = true;
            this.isActive3 = true;
        } 
        },
    changeIt3(a){
    this.isActive3 = !this.isActive3;
      if (this.isActive3 == false) {
          this.isActive1 = true;
          this.isActive2 = true;
      } 
    },
    gotolink(){
      this.$router.replace('/Work/list')
    },
    gotolink1(){
      this.$router.replace('/Work/list1')
    },
    gotolink2(){
      this.$router.replace('/Work/list2')
    },
    gotolink3(){
      this.$router.replace('/Work/list3')
    },
    onMoreWorks() {
      this.goWorkList();
    },
    goWorkList() {
      this.$router.push({
        path: "Work/list",
        query: {}
      });
    },
    goWork() {
      this.$router.push({
        path: "Work",
        query: {}
      });
    },
    goRoute(index) {
      this.$router.push({
        path: "/match",
        query: { pos: index }
      });
    },
    getNewsList() {
      getNewsList({ pageNum: 1, pageSize: 4 }).then(res => {
        const { total, rows = [] } = res.data;
        this.hotList = rows;
      });
    },
    onSelect(activeIndex) {
      this.activeIndex = activeIndex;
    },

    onDown() {
      // 8 展示8个
      const y = (this.timeline.length - 8) * 60;
      if (Math.abs(this.translateY) >= y) return;
      this.translateY -= 60;
    },

    onUp() {
      if (this.translateY >= 0) return;
      this.translateY += 60;
    },

    gotoWorks() {
      this.$router.push({
        path: "/Work/list"
      });
    },

    onMore() {
      const { href } = this.$router.resolve({
        path: "/Export"
      });
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
  #blink {
        visibility: visible;
    }
.homePage {
  // width: 1677px;
  .bannerBgc {
    margin-top: 82px;
    // z-index: -2;
    width: 100%;
    height: 800px;
    background: url("../../assets/image/index/index-banner.jpg") no-repeat
      center top;
    // background-size: cover;

    // min-height: 660px;
    .bg {
      height: 600px;
      background: transparent;
    }
  }
  .boxcontent {
    // width: 70%;
    text-align: center;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
    .stle {
      font-weight: 700;
      line-height: 30px;
    }
    .content {
      margin-top: -50px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 359px;
      height: 150px;
      background: url(../../assets/image/zhubootm.png) no-repeat center;
      .bgc {
        position: absolute;
        width: 359px;
        z-index: 0;
      }
      .content_text {
        z-index: 1;
      }
    }
  }
  .banner_bootom {
    background-color: rgb(249, 246, 237);
    width: 100%;
    height: 180px;
    margin-top: -50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    padding-top: 50px;
  }
  .coloechange {
    width: 60%;
    margin: 0 auto;
    text-align: left;
    .cont {
      width: 100%;
      display: flex;
      .name {
        padding: 10px 0;
        width: 45%;
        text-align: right;
        margin-right: 65px;
        color: #c0c0c0;
        letter-spacing: 5px;
        font-size: 14px;
      }
      .linebox {
        padding: 10px 0;
        width: 38%;
        display: flex;
        justify-content: flex-end;
        .line {
          background-color: rgb(37, 135, 125);
          width: 95%;
          height: 15px;
          //margin-left: 80vw;
        }
      }
    }
  }
  .announcement {
    padding: 50px 0 30px;
    background-color: #f4f9ff;
    .introduce {
      .title {
        margin: 0 auto;
        width: 150px;
        padding-left: 30px;
        border-left: 4px solid #5e94c1;
        font-size: 20px;
        font-weight: bold;
        color: #5e94c1;
      }
      .content {
        display: flex;
        justify-content: space-between;
        height: 300px;
        padding: 20px 200px;
        .left-content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 600px;
          padding: 20px;
          background-color: #fff;

          .top-info {
            line-height: 30px;
            font-size: 16px;
            text-align: left;
          }
          .bottom-btn {
            width: 100px;
            height: 30px;
            line-height: 30px;
            margin-top: 15px;
            border-radius: 15px;
            text-align: center;
            background-color: #5296d1;
            color: #fff;
          }
        }
        .right-content {
          width: 600px;
          height: 100%;
          .img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .product {
      padding: 20px 200px;
      background-color: #fff;
      .title {
        margin: 0 auto;
        width: 150px;
        padding-left: 30px;
        border-left: 4px solid #5e94c1;
        font-size: 20px;
        font-weight: bold;
        color: #5e94c1;
      }
      .top-search {
        position: relative;
        text-align: right;

        input {
          width: 250px;
          padding: 10px;
          border: none;
          outline: none;
          background-color: #f1f5fe;
        }
        .icon {
          position: absolute;
          top: 0px;
          right: 0;
          width: 35px;
          height: 35px;
          background: #5296d1;
          cursor: pointer;
        }
      }

      .bottom-info {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        height: 300px;
        .center-info {
          .center-img{
            height: 100%;
            margin: 0 5px;
            width: 240px;
            border: 2px solid #5296d1;
         
          .img {
            width: 150px;
            height: 100px;
            margin: 28px auto;
          }
          .txt {
            position: relative;
            width: 100%;
            height: 90px;
            line-height: 24px;
            padding-top: 10px;
            background-color: #5296d1;
            color: #fff;
            margin-top: 78px;
          }
          .tab {
            display: flex;
            position: absolute;
            left: 90px;
            bottom: 0;
            .left {
              width: 30px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              background-color: #fff;
              color: #000;
              font-family: 仿宋;
            }
            .right {
              width: 30px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              background-color: #3b709f;
              color: #fff;
              font-family: 仿宋;
            }
          }
        }
        .center-img1{
          box-shadow:#5296d1 0px 0px 18px inset;
          height: 100%;
            margin: 0 5px;
            width: 240px;
            border: 2px solid #5296d1;
         
          .img {
            width: 150px;
            height: 100px;
            margin: 28px auto;
          }
          .txt {
            position: relative;
            width: 100%;
            height: 90px;
            line-height: 24px;
            padding-top: 10px;
            background-color: #5296d1;
            color: #fff;
            margin-top: 78px;
          }
        }
        }
       
        .right-info {
          height: 100%;
          margin: 0 5px;
          .top-img{
            border: 2px solid #5296d1;
            width: 240px;
            .img > img {
              width: 80px;
              height: 50px;
              margin: 10px auto;
             
            }
            .txt {
              width: 100%;
              height: 70px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
            }
          }
          .bottom-img {
            border: 2px solid #5296d1;
            width: 240px;
            margin-top: 10px;
            .img > img {
              width: 80px;
              height: 50px;
              margin: 10px auto;
             
            }
            .txt {
              width: 100%;
              height: 70px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
            }
          }
          .top-img1{
            box-shadow:#5296d1 0px 0px 18px inset;
            border: 2px solid #5296d1;
            width: 240px;
            .img > img {
              width: 80px;
              height: 50px;
              margin: 10px auto;
             
            }
            .txt {
              width: 100%;
              height: 70px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
            }
          }
          .bottom-img1{
            box-shadow:#5296d1 0px 0px 18px inset;
            border: 2px solid #5296d1;
            width: 240px;
            margin-top: 10px;
            .img > img {
              width: 80px;
              height: 50px;
              margin: 10px auto;
             
            }
            .txt {
              width: 100%;
              height: 70px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
            }
          }
        }
        .info-item {
          height: 100%;
          margin: 0 5px;

          .product-center {
            position: relative;
            width: 280px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            background-color: #5197d5;
            color: #fff;
            font-weight: bold;
            .icon1 {
              display: inline-block;
              position: absolute;
              top: 16px;
              left: 30px;
              width: 3px;
              height: 16px;
              background-color: #fff;
            }
          }

          .type1 {
            position: relative;
            width: 280px;
            height: 50px;
            line-height: 50px;
            margin-top: 10px;
            text-align: center;
            background-color: #b1dcff;
            color: #fff;
            font-weight: bold;
            .icon2 {
              display: inline-block;
              position: absolute;
              top: 20px;
              left: 24px;
              width: 16px;
              height: 3px;
              background-color: #fff;
            }
          }

          .type2 {
            position: relative;
            width: 280px;
            height: 50px;
            line-height: 50px;
            margin-top: 10px;
            text-align: center;
            background-color: #5197d5;
            font-weight: bold;
            .icon2 {
              display: inline-block;
              position: absolute;
              top: 20px;
              left: 24px;
              width: 16px;
              height: 3px;
              background-color: #fff;
            }
          }
          .more {
            position: relative;
            width: 280px;
            height: 40px;
            line-height: 40px;
            margin-top: 20px;
            text-align: center;
            background-color: #3c6fa0;
            color: #fff;
            font-weight: bold;
            .type3 {
              position: absolute;
              top: 0;
              right: 0;
              width: 40px;
              height: 40px;
              background-color: #5096d4;
              font-family: 仿宋;
            }
          }
        }
      }
    }
    .service {
      margin-top: 20px;
      .title {
        margin: 0 auto;
        width: 150px;
        padding-left: 30px;
        border-left: 4px solid #5e94c1;
        font-size: 20px;
        font-weight: bold;
        color: #5e94c1;
      }

      .service-info {
        display: flex;
        justify-content: space-between;
        height: 300px;
        padding: 20px 200px;
        margin-top: 30px;
        .item {
          position: relative;

          .img {
            position: absolute;
            top: -35px;
            left: 50%;
            transform: translate(-50%);
            width: 70px;
            height: 70px;
            background-color: #5395d0;
            border-radius: 50%;
            img {
              margin: 10px auto;
              width: 50px;
              height: 50px;
            }
          }
          .text {
            width: 300px;
            padding: 50px 20px;
            line-height: 25px;
            background-color: #fff;
            text-align: left;
            font-size: 16px;
            .tip {
              margin-bottom: 10px;
              text-align: center;
              font-size: 20px;
              font-weight: bold;
              color: #5096d4;
            }
            .top-info {
            line-height: 30px;
            font-size: 16px;
            text-align: left;
          }
          }
        }
      }
    }
    .announcement_content {
      display: flex;
      // align-items: center;
      justify-content: center;
      padding-top: 40px;
      .announcement_text {
        width: 540px;
        height: 400px;
        margin-left: 60px;

        .button {
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          text-align: right;
        }
        .button:hover {
          color: #25877d;
        }
        .texts {
          cursor: pointer;
          width: 268px;
          height: 188px;
          overflow: hidden;
          border: 1px solid rgb(221, 221, 221);
          &:nth-child(2n + 2) {
            border-left: none;
          }
          &:nth-child(1),
          &:nth-child(2) {
            border-bottom: none;
          }
        }
      }
    }
    .news-box {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
    }
  }
  .announcement_video {
    width: 600px;
    height: 380px;
    cursor: pointer;
  }
  .judges {
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    .right {
      // margin-left: 400px;
      display: flex;
      // justify-content: space-around;
      // align-items: center;
      .right_img {
        margin-left: -100px;
        width: 324px;
        height: 350px;
      }
      .right_text {
        position: relative;
        width: 440px;
        margin-left: 56px;
        text-align: left;
        .semi {
          display: block;
          background: url("../../assets/image/yin.png") no-repeat right center;
          width: 45px;
          height: 45px;
        }
        .detail {
          margin-top: 50px;
          line-height: 22px;
          height: 140px;
          text-indent: 24px;
        }
        .more-btn {
          position: absolute;
          left: 0;
          bottom: 0;
          line-height: 30px;
          text-align: right;
          width: 100%;
        }
      }
    }
    .left {
      background-color: rgb(249, 246, 237);
      padding: 70px 200px 0 50px;
      height: 550px;
      box-sizing: border-box;
      .left_name {
        display: block;
        padding: 20px 0;
        line-height: 20px;
        padding-left: 50px;
        position: relative;
        &::before {
          content: "";
          width: 14px;
          height: 2px;
          overflow: hidden;
          background-color: #c7ad88;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          transition: all 0.25s;
        }
      }
      .left_name.selected {
        color: #25877d;
        &::before {
          background-color: #25877d;
          width: 30px;
        }
      }
    }
  }
  .good {
    display: flex;
    justify-content: center;
    align-items: center;
    .good_left {
      width: 810px;
      height: 668px;
    }
    .work-time-line {
      width: 562px;
      height: 100%;
      margin: auto;
      position: relative;
      // background: url('../../assets/image/index/work-logo.png') no-repeat center center;
      .times {
        position: absolute;
        font-size: 18px;
        line-height: 22px;
        transform: translate(-14px, 20px);
        &:hover,
        &.actived {
          color: #25877d;
        }
      }
      .times1 {
        top: 60px;
        left: 242px;
        color: #25877d;
      }
      .times2 {
        top: 120px;
        left: 358px;
      }
      .times3 {
        top: 180px;
        left: 422px;
      }

      .times4 {
        top: 240px;
        left: 442px;
      }
      .times5 {
        top: 300px;
        left: 442px;
      }
      .times6 {
        top: 360px;
        left: 442px;
      }

      .times7 {
        top: 440px;
        left: 422px;
      }
      .times8 {
        top: 500px;
        left: 352px;
      }

      .times9 {
        top: 550px;
        left: 242px;
      }
      .times10 {
        top: 500px;
        left: 120px;
      }
      .times11 {
        top: 440px;
        left: 80px;
      }
      .times12 {
        top: 360px;
        left: 60px;
      }

      .times13 {
        top: 300px;
        left: 60px;
      }
      .times14 {
        top: 240px;
        left: 60px;
      }

      .times15 {
        top: 180px;
        left: 60px;
      }
      .times16 {
        top: 120px;
        left: 60px;
      }
      .times17 {
        top: 60px;
        left: 60px;
      }
    }
    .good_right {
      // height: 600px;
      margin-left: 20px;
      text-align: right;
      .more-btn {
        line-height: 20px;
        margin-bottom: 10px;
        display: inline-block;
      }
    }
    .works-img-box {
      display: flex;
      height: 600px;
      margin-top: 100px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .works-img {
        width: 395px;
      }
    }
  }
}
.left-name-list {
  .icon {
    display: block;
    font-size: 0;
    background-position: center center;
    width: 100%;
    height: 16px;
    background-repeat: no-repeat;
    background-image: url("../../assets/image/index/up.png");
  }
  .icon.down {
    background-image: url("../../assets/image/index/down.png");
  }
}
.scroll-list-box {
  height: 360px;
  overflow: hidden;
  position: relative;
  margin: 5px 0;
  .scroll-list {
    transition: all 0.25s;
  }
}
.img-title {
  text-align: center;
}
.index-img-icon {
  cursor: pointer;
}
.works-box {
  background: url("../../assets/image/works-bg.jpg") no-repeat center top;
}
.works-main {
  height: 1064px;
  background: url("../../assets/image/works-main.jpg") no-repeat center top;
  .left-name-list {
    width: 180px;
    padding-left: 270px;
    padding-top: 140px;
    .icon {
      display: block;
      font-size: 0;
      background-position: center center;
      width: 100%;
      height: 16px;
      background-repeat: no-repeat;
      background-image: url("../../assets/image/index/up.png");
    }
    .icon.down {
      background-image: url("../../assets/image/index/down.png");
    }
  }
  .scroll-list-box {
    height: 480px;
    overflow: hidden;
    position: relative;
    margin: 5px 0;
    .scroll-list {
      transition: all 0.25s;
    }
  }
  // works
  .left_name {
    display: block;
    padding: 20px 0;
    line-height: 20px;
    font-size: 15px;
    padding-left: 50px;
    position: relative;
    &::before {
      content: "";
      width: 22px;
      height: 4px;
      overflow: hidden;
      background-color: #c7ad88;
      border-radius: 4px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      transition: all 0.25s;
    }
  }
  .left_name.selected {
    color: #25877d;
    font-weight: 700;
    &::before {
      background-color: #25877d;
      width: 40px;
    }
  }
}
.banner-text-box {
  top: 130px;
}
// @media screen and (max-width: 1580px) {
//   .banner-text-box {
//     transform: translateX(-50%) scale(.8);
//     top: 180px;
//   }
// }
// @media screen and (max-width: 1280px) {
//   .banner-text-box {
//     transform: translateX(-50%) scale(.65);
//     top: 220px;
//   }
// }
.s-text-box-1 {
  position: absolute;
  width: 32%;
  height: 28%;
  top: 20%;
  left: 19%;
  background: rgba(228, 76, 88, 0.9);
  color: #fff;
  font-size: 36px;
}
.s-text-box-2 {
  position: absolute;
  width: 32%;
  height: 28%;
  top: 20%;
  left: 33%;
  background: rgba(228, 76, 88, 0.9);
  color: #fff;
  font-size: 36px;
}
.s-text-box-3 {
  position: absolute;
  width: 32%;
  height: 28%;
  top: 20%;
  left: 57%;
  background: rgba(228, 76, 88, 0.9);
  color: #fff;
  font-size: 36px;
}
.saidao-text {
  padding-top: 60px;
}
</style>
<style lang="scss">
.carousel-box {
  // .el-carousel__container {height: auto;min-height: 300px;}
  .el-carousel__button {
    background: #c1c1c1;
  }
  .is-active .el-carousel__button {
    background: #25877d;
  }
}
.homePage {
  .footerbox {
    margin-top: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/homePage/homePage.vue